import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PublicHeader, Breadcrumbs, SeoHead } from "@/components/PublicSeo";
import { SeoFooter } from "@/components/SeoFooter";

const GROUP = { 1: "By category, city, language or platform", 2: "Two-filter pages", 3: "Three-filter pages", 4: "Four-filter pages" };

export default function Directory() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/seo/directory").then((r) => setD(r.data)).catch(() => setD({ groups: [], creators: [] })); }, []);
  const site = d?.canonical_url;
  return (
    <div className="min-h-screen bg-background" data-testid="directory-page">
      <SeoHead title="Influencer Directory – Browse Creators by Category, City & Platform | InfluencerCollab"
        description="Browse every InfluencerCollab creator page by category, city, language and platform, and open public creator profiles to invite them to your brand campaign."
        canonical={site} robots="index,follow" />
      <PublicHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <Breadcrumbs items={[{ label: "Home", path: "/" }, { label: "Influencers", path: "/influencer-directory" }]} />
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mb-4">Influencer directory</h1>
        <p className="text-muted-foreground max-w-3xl mb-10">Every creator page listed here has enough public profiles to be useful. Pages update automatically as creators join.</p>
        {!d ? <p className="text-muted-foreground">Loading…</p> : (
          <>
            {d.groups.length === 0 && <p className="text-muted-foreground" data-testid="directory-empty">No creator pages yet — check back soon.</p>}
            {d.regions?.length > 0 && (
              <section className="mb-10" data-testid="directory-regions">
                <h2 className="font-heading font-bold text-lg mb-3">By region</h2>
                <ul className="flex flex-wrap gap-2">{d.regions.map((r) => <li key={r.path}><Link to={r.path} className="inline-block rounded-full border border-border px-3 py-1.5 text-sm hover:border-brand-pink">{r.label}</Link></li>)}</ul>
              </section>
            )}
            {d.groups.map((g) => (
              <section key={g.depth} className="mb-10" data-testid={`directory-group-${g.depth}`}>
                <h2 className="font-heading font-bold text-lg mb-3">{GROUP[g.depth]}</h2>
                <ul className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
                  {g.pages.map((p) => <li key={p.path}><Link to={p.path} className="text-sm hover:text-brand-pink">{p.label} <span className="text-muted-foreground">({p.count})</span></Link></li>)}
                </ul>
              </section>
            ))}
            {d.creators.length > 0 && (
              <section className="mb-10" data-testid="directory-creators">
                <h2 className="font-heading font-bold text-lg mb-3">Creator profiles</h2>
                <ul className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
                  {d.creators.map((c) => <li key={c.slug}><Link to={`/creators/${c.slug}`} className="text-sm hover:text-brand-pink">{c.name}</Link></li>)}
                </ul>
              </section>
            )}
          </>
        )}
      </main>
      <SeoFooter />
    </div>
  );
}
